import { fromJS } from 'immutable';
import { createReducer } from 'redux-create-reducer';
import * as actions from './actions';
import {
  WER_REFEENCE_PDFS,
  WEB_REF_FAIR_PROCESSING,
  WEB_BUSINESS_TERMS_CONDITIONS,
  WEB_BUSINESS_TARIFF_GUIDE,
  WEB_FSCS_INFORMATION,
  BANK_ID,
  PRIMARY_BANK_ID,
  CUSTOMER_UUID,
  PRODUCT_NAME,
  SOURCE_ID,
  WEB_REF_DGS,
  WEB_REF_BUS_DATA_PROTECTION,
  BANK_ID_CYB,
  LINK_CODE_KEY,
  APPLICANT_FLOW,
  WEB_REF_SWITCH_PAYMENT,
  WEB_REF_SWITCH_PAYMENT_FULL,
  WEB_REF_ONLINE_SERVICE_TARIFF,
  WEB_REF_DIGITAL_BANKING_BUSINESS_TERMS
} from '../../utils/constants';
import { FETCH_CUSTOMERBYID_SUCCESS } from '../customers';
import { getQueryStringValueByName } from '../../utils';
import sessionRedirectUtil from '../../utils/sessionRedirectUtils';

export const WEB_REFS = [
  WEB_REF_FAIR_PROCESSING,
  WEB_BUSINESS_TERMS_CONDITIONS,
  WEB_BUSINESS_TARIFF_GUIDE,
  WEB_FSCS_INFORMATION,
  WEB_REF_DGS,
  WEB_REF_BUS_DATA_PROTECTION,
  WEB_REF_SWITCH_PAYMENT,
  WEB_REF_SWITCH_PAYMENT_FULL,
  WEB_REF_ONLINE_SERVICE_TARIFF,
  WEB_REF_DIGITAL_BANKING_BUSINESS_TERMS
];

export const initialState = fromJS({
  bank_id: 'cb',
  brand_id: 'cb',
  loading: false
});

export default createReducer(initialState, {
  [actions.FETCH_CONFIG]: state => state.set('loading', true),
  [actions.FETCH_CONFIG_FAILED]: (state, action) =>
    state.set('loading', false).set('error', action.error),
  [actions.FETCH_CONFIG_SUCCESS]: (state, action) =>
    state
      .set('loading', false)
      .merge(action.payload)
      .set(PRODUCT_NAME, getProductName())
      .set(
        LINK_CODE_KEY,
        getQueryStringValueByName(LINK_CODE_KEY) ||
          getQueryStringValueByName(LINK_CODE_KEY, sessionRedirectUtil.getRefreshUrl())
      )
      .set(SOURCE_ID, getQueryStringValueByName(SOURCE_ID))
      .set(PRIMARY_BANK_ID, getQueryStringValueByName(PRIMARY_BANK_ID)),
  [actions.DOWNLOAD_PDF_LIST_SUCCESS]: (state, action) =>
    state.set(
      WER_REFEENCE_PDFS,
      getUrlByWebReference(action.payload.document_list, state.get(BANK_ID))
    ),
  [actions.REQUEST_TOKEN_SUCCESS]: (state, action) => {
    const { bank_id } = action.payload;
    return state.set(BANK_ID, bank_id);
  },
  [FETCH_CUSTOMERBYID_SUCCESS]: (state, action) =>
    !action.payload.principle_contact ? state.set(CUSTOMER_UUID, action.meta.id) : state,
  [actions.SET_RESUME_PARAM]: (state, action) =>
    state
      .set('caseId', action.data.caseId)
      .set('caseType', action.data.caseType)
      .set(PRODUCT_NAME, action.data.productName),
  [actions.REDIRECT_TO_SIGNIFICANT_PAGE]: (state, action) => state.set(APPLICANT_FLOW, action.data),
  [actions.RESET_SECONDARY_EXISTING_NTB]: (state, action) =>
    state
      .set(BANK_ID, action.data)
      .set('access_token', null)
      .set('misMatchBankId', true)
});

const getUrlByWebReference = (list, bank_id) =>
  list.filter(referece => {
    const ref_bank = referece.brand.toLowerCase();
    return (
      (bank_id.toLowerCase() === ref_bank || ref_bank === BANK_ID_CYB) &&
      WEB_REFS.indexOf(referece.web_reference) > -1
    );
  });

const getProductName = () => {
  const pName = getQueryStringValueByName(PRODUCT_NAME) || sessionStorage.getItem(PRODUCT_NAME);
  sessionStorage.removeItem(PRODUCT_NAME);
  return pName;
};
